/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

const defaultSize = 1.3
const defaultInnerSize = defaultSize - 0.5

const Checkbox = ({
  color,
  tourStep,
  circle,
  active,
  onChange,
  disabled,
  size = defaultSize,
  innerSize = defaultInnerSize
}) => {
  color = color || COLORS.purple
  if (!active) color = COLORS.light3
  if (!!disabled) color = COLORS.light2
  const style = css`
    border: solid 1px ${color};
    border-radius: 2px;
    height: ${size}rem;
    width: ${size}rem;
    ${circle ? `border-radius: ${size}rem;` : ''}
    display: flex;
    align-items: center;
    justify-content: center;

    & > .innerCircle {
      opacity: ${active ? 1 : 0};
      border-radius: 2px;
      background-color: ${color};
      ${circle ? `border-radius: ${size}rem;` : ''}
      width: ${innerSize}rem;
      height: ${innerSize}rem;
    }
  `

  const handleChange = () => {
    if (!!disabled) return
    onChange && onChange(!active)
  }

  return (
    <div datatour={tourStep} className="circle" css={style} onClick={handleChange}>
      <div className="innerCircle"></div>
    </div>
  )
}

export default Checkbox
